const ORGS_WITHOUT_EVAL_REQUIREMENT = [
  'eaf38541-2bed-4fb8-b2f3-203fe8d2d640',
];

/**
 * Compute which note types should be disabled based on case history.
 *
 * Rules:
 * - If an Initial Evaluation already exists for the case, disable creating another
 * - If no Initial Evaluation exists yet, disable daily_note and progress_note
 *   (unless the organization is exempt from this requirement)
 *
 * @param {number|string} caseId
 * @param {Object} apiService - The API service instance
 * @param {string} [organizationId] - The organization ID
 * @returns {Promise<Object>} Map of { [noteType]: 'reason string' } for disabled types
 */
export async function computeCaseNoteConstraints(caseId, apiService, organizationId) {
  const constraints = {};

  if (!caseId) return constraints;

  try {
    const evalNotes = await apiService.getClinicalNotes({ case_id: caseId, note_type: 'initial_evaluation', limit: 1 });
    const evalItems = evalNotes?.items || evalNotes || [];
    const hasEval = evalItems.length > 0;

    if (hasEval) {
      constraints.initial_evaluation = 'Initial Evaluation already exists for this case';
    } else if (!ORGS_WITHOUT_EVAL_REQUIREMENT.includes(organizationId)) {
      const [progressNotes, reassessmentNotes] = await Promise.all([
        apiService.getClinicalNotes({ case_id: caseId, note_type: 'progress_note', limit: 1 }),
        apiService.getClinicalNotes({ case_id: caseId, note_type: 'reassessment', limit: 1 }),
      ]);
      const hasProgress = (progressNotes?.items || progressNotes || []).length > 0;
      const hasReassessment = (reassessmentNotes?.items || reassessmentNotes || []).length > 0;

      if (!hasProgress && !hasReassessment) {
        constraints.daily_note = 'Complete Initial Evaluation first';
        constraints.progress_note = 'Complete Initial Evaluation first';
      }
    }
  } catch (err) {
    console.error('Error computing case note constraints:', err);
  }

  return constraints;
}
